export const USER_GROUP_PROGRAM_CODE = "USERGROUPMASTER";

export const GROUP_PERMISSION_TYPES = [
  "ADD",
  "EDIT",
  "DELETE",
  "EXPORT",
  "CHECK",
  "APPROVE",
  "REPORT",
  "PROCESS",
];
export const RESERVED_GROUP_NAMES = [
  "Admin",
  "UNION",
  "PLANT",
  "BMC",
  "DCS",
  "APPROVER",
  "CHECKER",
  "DEPTADMIN",
];

export const RESERVED_GROUP_TOOLTIP =
  "Built-in role — managed in backend configuration.";

export const isReservedGroupName = (name = "") =>
  RESERVED_GROUP_NAMES.some(
    (reserved) => reserved.toLowerCase() === String(name).trim().toLowerCase()
  );

// Anything outside these falls back to `createdAt desc` server-side without erroring.
export const GROUP_TABLE_SORT_KEYS = [
  "ugId",
  "ugName",
  "ugDesignation",
  "ugCode",
  "status",
  "entityType",
  "totalUsers",
  "createdAt",
  "updatedAt",
];

export const GROUP_USERS_SORT_KEYS = [
  "uId",
  "name",
  "phone",
  "status",
  "createdAt",
];

export const GROUP_STATUSES = ["Active", "Inactive"];

export const GROUP_ENTITY_TYPES = ["UNION", "PLANT", "BMC", "DCS"];
